var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3332 29.3334H21.3332M26.6665 40H21.3332M42.6665 18.6667H21.3332M53.3332 18.1334V45.8667C53.3332 50.3471 53.3332 52.5873 52.4612 54.2986C51.6942 55.8039 50.4704 57.0278 48.9651 57.7948C47.2538 58.6667 45.0136 58.6667 40.5332 58.6667H23.4665C18.9861 58.6667 16.7459 58.6667 15.0346 57.7948C13.5293 57.0278 12.3054 55.8039 11.5385 54.2986C10.6665 52.5873 10.6665 50.3471 10.6665 45.8667V18.1334C10.6665 13.653 10.6665 11.4127 11.5385 9.70145C12.3054 8.19615 13.5293 6.97231 15.0346 6.20532C16.7459 5.33337 18.9861 5.33337 23.4665 5.33337H40.5332C45.0136 5.33337 47.2538 5.33337 48.9651 6.20532C50.4704 6.97231 51.6942 8.19615 52.4612 9.70145C53.3332 11.4127 53.3332 13.653 53.3332 18.1334Z",
    stroke: "#414651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.639f3dbb9cf0dc54cd6ff01d7bf1062a.svg";
export { ForwardRef as ReactComponent };